import IRHMA1 from "../../../../images/content/introduction/irhma/irhma1.png";
import IRHMA2 from "../../../../images/content/introduction/irhma/irhma2.jpg";
import IRHMA3 from "../../../../images/content/introduction/irhma/irhma3.jpg";

export const IRHMAImages = [
	{
		id: "irhma-logo",
		imageUrl: IRHMA1,
		imageAlt: "Logo of the International Roundtable of Household Appliance Manufacturer Associations",
	},
	{
		id: "irhma-meeting-outdoor",
		imageUrl: IRHMA2,
		imageAlt: "Group picture of an IRHMA meeting, outside, 10 people are present",
	},
	{
		id: "irhma-meeting-indoor",
		imageUrl: IRHMA3,
		imageAlt: "Group picture of an IRHMA meeting, inside, 16 people are present",
	},
];
